@let mainContentArticle = mainContentArticle$ | async;
@let articlePicture = mainContentArticle?.picture;
@let pageContactInfo = pageContactInfo$ | async;
@let allianzContactInfoSectionLinks = allianzContactInfoSectionLinks$ | async;

<div class="pr-xxlarge-b">
  @if (mainContentArticle) {
    <h2 data-testid="main-content-article-title" class="font-heading-3 ms-medium-b">
      {{ mainContentArticle.teaserTitle }}
    </h2>
    <div [innerHtml]="mainContentArticle.detailText | finSafe: 'html'" class="font-body-1 ms-large-b"></div>
  }

  @if (articlePicture) {
    <div class="article-image-container z0 overflow-hidden ms-xlarge-y relative">
      <fin-content-image
        [fillParent]="true"
        [scale]="false"
        [isLazyLoad]="false"
        [imageData$]="articlePicture | finToObservable"
      />
    </div>
  }

  <h2 class="font-heading-4 ms-xlarge-y">
    {{ 'MMB.allianz.travelInsurancePage.availableInsurancesTitle' | finLocalization }}
  </h2>

  @if (showComprehensiveInsurancePanel$ | async) {
    <fin-mmb-insurance-panel
      data-testid="comprehensive-travel-insurance"
      insuranceName="comprehensiveTravelInsurance"
    />
    <div class="ms-medium-y flex flex--center">
      <div class="divider-line flex-1 flex--basis0 nordic-blue-100-bg"></div>
      <span class="divider-text ms-xsmall-x font-body-1 medium-type">{{
        'MMB.allianz.travelInsurancePage.accordionDividerText' | finLocalization
      }}</span>
      <div class="divider-line flex-1 flex--basis0 nordic-blue-100-bg"></div>
    </div>
  }

  <fin-mmb-insurance-panel data-testid="on-trip-travel-insurance" insuranceName="onTripTravelInsurance" />

  <div class="partner-with-section flex flex--column ms-xlarge-y">
    <div class="flex flex--middle regular-type font-body-2">
      <span class="ms-xxsmall-r">{{ 'MMB.allianz.travelInsurancePage.partnerWith' | finLocalization }}</span>
      <fcom-icon
        aria-hidden="true"
        class="partner-logo"
        [category]="IconLibrary.CUSTOM"
        [name]="CustomIcon.ALLIANZ_LOGO"
      />
    </div>
    <div>
      <fcom-button
        [text]="'MMB.allianz.travelInsurancePage.ctaButtonText' | finLocalization"
        [href]="'MMB.allianz.travelInsurancePage.ctaButtonHref' | finLocalization"
        [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
        [openInNewTab]="true"
        [externalLink]="true"
        [icon]="{ name: SvgLibraryIcon.EXTERNAL_TAB, position: IconPosition.RIGHT }"
      />
    </div>
  </div>

  @if (pageContactInfo) {
    <div data-testid="contact-info-section" class="flex ms-xsmall-t">
      <div class="info-icon-container ms-small-r">
        <fcom-icon aria-hidden="true" class="icon-medium" [name]="SvgLibraryIcon.INFO_BLOCK" />
      </div>
      <div>
        <cms-rich-text
          class="ms-xsmall-t"
          extraClasses="flex--column"
          [headerStyles]="['is-hidden']"
          [content$]="pageContactInfo$"
        />
        <div
          data-testid="contact-info-section-links"
          class="contact-section-link-container flex flex--wrap ms-xsmall-t"
        >
          @for (link of allianzContactInfoSectionLinks; track link.label) {
            <fcom-link class="" [href]="link.href" [openInNewTab]="true" [external]="true">
              {{ link.label }}
            </fcom-link>
          }
        </div>
      </div>
    </div>
  }
</div>
